import { useFormContext } from "react-hook-form";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import { UserRole } from "../../../__generated__/graphql";
import { optionalHttpUrlRule } from "../../../utils/validators";

const Personal = () => {
  const {user} = useCurrentUser()

  const { register, formState: { errors } } = useFormContext()
  const isAdmin = user.role === UserRole.ACCOUNT_ADMIN;

  return (
    <div className="mt-6 grid grid-cols-4 gap-6">
      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="firstname"
          className="block text-sm font-medium text-gray-700"
        >
          First Name
        </label>

        <input
          type="text"
          name="firstname"
          id="firstname"
          autoComplete="cc-given-name"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          {...register('firstname')}
        />
      </div>

      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="last-name"
          className="block text-sm font-medium text-gray-700"
        >
          Last Name
        </label>

        <input
          type="text"
          name="last-name"
          id="last-name"
          autoComplete="cc-family-name"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          {...register('lastname')}
        />

      </div>

      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="country"
          className="block text-sm font-medium text-gray-700"
        >
          Avatar
        </label>

        {/* <img
              src={user.avatarUrl}
              className="h-9 w-9 rounded-full inline-block"
              alt="avatar"
            /> */}
        <input
          type="text"
          name="avatarUrl"
          id="avatarUrl"
          autoComplete="cc-family-name"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          {...register('avatarUrl', { validate: { format: optionalHttpUrlRule } })}
        />
        {errors.avatarUrl && (
          <span className="text-red-500">{errors.avatarUrl.message}</span>
        )}
      </div>

      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="title"
          className="block text-sm font-medium text-gray-700"
        >
          Title
        </label>
        {isAdmin ? (
          <input
            type="text"
            name="title"
            id="title"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
            {...register('title')}
          />
        ) : (
          <div className="mt-1 block w-full bg-white shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
            {user.title}
          </div>
        )}
      </div>
      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="email-address"
          className="block text-sm font-medium text-gray-700"
        >
          Email address
        </label>
        <div className="mt-1 block w-full bg-white shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
          {user.email}
        </div>
      </div>
      <div className="col-span-4 sm:col-span-2">
        <label
          htmlFor="usertype"
          className="block text-sm font-medium text-gray-700"
        >
          User type
        </label>
        {false ? (
          <select
            id="usertype"
            name="usertype"
            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
          >
            <option>Admin</option>
            <option>Regular Member</option>
          </select>
        ) : (
          <div className="mt-1 block w-full bg-white shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
            {" "}
            {user.role}
          </div>
        )}
      </div>
    </div>
  )
};

export default Personal;
